import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type VenueListSportInfo = {
  sportCode: string;
  displayName: string;
  icon: string | null;
  color: string | null;
  bgColor: string | null;
};

export type VenueSummary = {
  id: string;
  name: string;
  slug: string;
  address: string | null;
  city: string | null;
  province: string | null;
  sports: VenueListSportInfo[];
  imageUrl: string | null;
  totalUnits: number | null;
  lowestStartingPrice: number | null;
  currency: string | null;
};

export type VenueSportSummary = {
  sportCode: string;
  displayName: string;
  icon: string | null;
  description: string | null;
  startingPrice: number | null;
  currency: string | null;
  allowedDurations: number[];
  minPlayers: number | null;
  maxPlayers: number | null;
  availableUnits: number | null;
  color: string | null;
  bgColor: string | null;
};

export type VenueDetail = {
  id: string;
  name: string;
  slug: string;
  address: string | null;
  city: string | null;
  province: string | null;
  timezone: string | null;
  operatingHours: Record<string, { open: string; close: string } | undefined>;
  sports: VenueSportSummary[];
  imageUrl: string | null;
  cancellationSummary: string | null;
};

export function useVenuesList(sport?: string, city?: string) {
  const params = new URLSearchParams();
  if (sport) params.set('sport', sport);
  if (city) params.set('city', city);
  const qs = params.toString();
  return useQuery({
    queryKey: ['venues', sport, city],
    queryFn: () =>
      apiClient<VenueSummary[]>(`/venues${qs ? '?' + qs : ''}`, { skipAuth: true }),
  });
}

export function useVenueBySlug(slug: string | undefined) {
  return useQuery({
    queryKey: ['venue', slug],
    queryFn: () => apiClient<VenueDetail>(`/venues/${slug}`, { skipAuth: true }),
    enabled: !!slug,
  });
}
